import { BrokenLinkIcon } from 'library/icons';
import { IllustrationView } from 'modules/shared/features/illustration';
import { useNavigate, useSearchParams } from 'react-router-dom';

const MicrosoftIllustration = () => {
    return (
        <div className="flex items-center gap-5">
            <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
            <BrokenLinkIcon />
            <img className="h-10" src="/plugins-images/microsoft.svg" alt="Microsoft" />
        </div>
    );
};

const MicrosoftErrorPage = () => {
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    const errorTitle = searchParams.get('title');
    const errorMessage = searchParams.get('message');

    return (
        <IllustrationView
            className="justify-center h-screen"
            illustration={<MicrosoftIllustration />}
            // title="Microsoft Authentication Failed"
            title={errorTitle}
            message={
                <>
                    {/* We couldn't connect to your Microsoft account. Please check your credentials or try again.
                     */}
                    {errorMessage}
                    <div className="mt-2">
                        <button
                            onClick={() => navigate(-1)}
                            className="text-primary font-medium cursor-pointer bg-transparent border-none p-0"
                        >
                            Back to home
                        </button>
                        {/* <Link to={'/'} replace className="text-primary font-medium cursor-pointer">
                            Back to home
                        </Link> */}
                    </div>
                </>
            }
        />
    );
};

export default MicrosoftErrorPage;
